import React from 'react';
import HelpItem, { IHelpItem } from './HelpItem';

const HelpGroup = (props: { data: { name: string, helpItems: IHelpItem[] } }) => {
  const { data } = props;
  const helpItems = data ? data.helpItems.map(item => (
    <HelpItem
      key={item.name}
      data={item}
    />
  )) : null;

  return (
    <div id="stories" data-section-name={data.name}>
      <h1 className="heading heading--1">{data.name}</h1>
      <ul
        id="filter-list-1"
        className="js-filter-list items items--list"
      >
        {helpItems}
      </ul>
    </div>
  );
};

export default HelpGroup;
